import React from 'react';
import { useNavigate } from 'react-router';
import { useSelectedMenu } from 'services/useSelectedMenu';
import { SidebarMenu, MenuSelection } from 'components/views/organisms/SidebarMenu';
import { ignore } from 'utility/ignore';

export type MenuProps = {}

export function Menu(props: MenuProps) {
    ignore(props);

    const menuHref: Record<MenuSelection, string> = {
        'Clock': 'clock',
        'Dashboard': 'dashboard',
        'Drive': 'drive',
        'Cockpit': 'cockpit',
        'RTC': 'rtc',
        'Setting': 'setting'
    };

    const selectedMenu = useSelectedMenu();
    const navigate = useNavigate();

    return <SidebarMenu
        selectedItem={selectedMenu as MenuSelection}
        onSelect={name => navigate(`../console/${menuHref[name]}`)}
    />;
}
